import './App.css';
import { Route, Routes } from 'react-router-dom';
import Inviter from './components/Inviter';
import Provider from './components/Provider';
import Admin from './components/Admin';
import AdminProviderRevise from './components/AdminProviderRevise';
import AdminProviderResendInvitation from './components/AdminProviderResendInvitation';
import Login, { Logout } from './components/Auth';
import LoginGoogle from './components/LoginGoogle';
import ProviderDocuments from './components/ProviderDocuments';
import ProviderGeneralData from './components/ProviderGeneralData';
import ProviderContacts from './components/ProviderContacts';
import ProviderQuestionnaires from './components/ProviderQuestionnaires';
import ProviderBankAccounts from './components/ProviderBankAccounts';
import SuperUser from './components/SuperUser';
import SuperUserCreateUser from './components/SuperUserCreateUser';
import SuperUserProviderRevise from './components/SurUserProviderRevise';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Login />} />
      <Route path='/auth-google' element={<LoginGoogle />} />
      <Route path='/logout' element={<Logout />} />
      <Route path='/invitador' element={<Inviter />} />
      <Route path='/proveedor' element={<Provider />} />
      <Route path='/proveedor-documentos' element={<ProviderDocuments />} />
      <Route path='/proveedor-datos-generales' element={<ProviderGeneralData />} />
      <Route path='/proveedor-contactos' element={<ProviderContacts />} />
      <Route path='/proveedor-cuestionarios' element={<ProviderQuestionnaires />} />
      <Route path='/proveedor-cuentas-bancarias' element={<ProviderBankAccounts />} />
      <Route path='/administrador' element={<Admin />} />
      <Route path='/administrador-proveedor-reenviar-invitacion/:id/:email/:rfc' element={<AdminProviderResendInvitation />} />
      <Route path='/administrador-proveedor-revision/:provider/:rfc' element={<AdminProviderRevise />} />
      <Route path='/super-usuario' element={<SuperUser />} />
      <Route path='/super-usuario-crear-usuario' element={<SuperUserCreateUser />} />
      <Route path='/super-usuario-proveedor-revision/:provider/:rfc/:estatus' element={<SuperUserProviderRevise />} />
    </Routes>
  );
}

export default App;
